__turbopack_context__.v({
  "tooltip": "f-y8VG_tooltip",
});
